'use strict';
import Backbone from 'backbone';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
import Analytics from '../Analytics/Analytics';
const NewsletterBanner = Backbone.View.extend ({
  events: {
    'click .ContentWithCtaBoW-link': 'newsLetterSignUp'
  },
  initialize: function() {
    this.$newsLetterBannerExists = this.$el.find('.ContentWithCtaBoW-link');
    this.bannerNameExists = this.$newsLetterBannerExists[0] && this.$newsLetterBannerExists[0].href;
    this.bannerName = this.bannerNameExists ? this.$newsLetterBannerExists[0].href.split('/').pop() : undefined;
    if (EnableAdobeAnalytics.isEnabled()) {
      Analytics.adobeInternalCampaignView(this.bannerName);
    }
  },
  newsLetterSignUp: function() {
    if (EnableAdobeAnalytics.isEnabled()) {
      Analytics.adobeInternalCampaignClick(this.bannerName);
    }
  }
},
{
  create: function($parent) {
    $parent.find('.Footer-Banner').each(function(n, el) {
      new NewsletterBanner({
        el: el
      });
    });
  }
});
module.exports = NewsletterBanner;



// WEBPACK FOOTER //
// ./assets/components/Newsletters/NewsletterBanner.js